<template>
    <section class="container container--calcPadding margin-both-xl">
        <div class="frame-container" v-html="data.google_map_iframe"></div>
    </section>
</template>


<script>
export default {
    props : ['data']
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-map{
    .frame-container{
        height: 0;
        padding-bottom: 40.3%;
        overflow: hidden;
        position: relative;
        min-height: 300px;
        iframe{
            position: absolute;
            top:0;
            left: 0;
            right:0;
            bottom: 0;
            width: 100%;
            height: 100%;
        }
    }
}
</style>